import { Box, Button, MenuItem, TextField, Typography } from "@mui/material";
import SearchContainer from "components/SearchContainer";
import Table from "components/Table";
import { useEffect, useState } from "react";
import { useMutation, useQuery } from "react-query";
import { useLocation, useNavigate } from "react-router-dom";
import { ResType } from "types";
import { getTracesDemandFinancialYears } from "utils/getFinancialYears";
import {
  clientCategories,
} from "./constants";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import useTitle from "hooks/useTitle";
// import { getOrganizationPreference } from "api/services/common";
import { snack } from "components/toast";
import { exportTracesIncomeTaxDemands, getIncomeTaxDemands } from "api/services/automation/income-tax-tan";
import { usePermissions } from "context/PermissionsProvider";
import AccessDenied from "views/atom-pro/Access/accessDenide";
import { Permissions } from "data/permissons";
import { exportTanIncomeTaxForms } from "api/services/automation/income-tax-tan";
import { getCurrentFormattedDateTime } from "utils";
import { handleError } from "utils/handleError";
import { SortDirection } from "data/constants";
import _ from "lodash";
import sortHandler from "components/Table/SortHandler";
import { formattedAmount } from "utils/formattedAmount";
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';


const TanIncomeTaxDemands = () => {
  useTitle("ATOM Pro | Traces Outstanding Demand");
  const navigate = useNavigate();
  const [search, setSearch] = useState("");
  const [page, setPage] = useState<number>(0);
  const [pageCount, setPageCount] = useState<number>(10);
  const [totalCount, setTotalCount] = useState<number>(0);
  const { permissions } = usePermissions();

  const [filters, setFilters] = useState<any>({
    formCode: null,
    filingType: null,
    financialYear: null,
    clientCategory: null,
    udinStat: null,
    quarter: null,
  });
  const forms = ["24Q","26Q","27Q","27EQ"];
  const financialYear = getTracesDemandFinancialYears();
  const quarters = ["Q1", "Q2", "Q3", "Q4"];

  // const location = useLocation();
  // const state: any = location.state;

  // const { data: incomeTaxAccess, isLoading: isLoadingIncomeTaxAccess }: ResType = useQuery(
  //   ["Income Tax Access Check"],
  //   getOrganizationPreference,
  //   {
  //     onSuccess: (res: any) => {
  //       if (res?.data?.automationConfig?.incomeTax === "YES") {
  //       } else {
  //         snack.error("Please subscribe Atom Pro Income tax");
  //         navigate("/atom-pro/incomeTaxLimit");
  //       }
  //     },
  //     // enabled: permissions.includes(Permissions.VIEW_ALL_CLIENT_MANAGERS) || permissions.includes(Permissions.VIEW_ASSIGNED_CLIENT_MANAGERS)
  //   }
  // );
  let defaultColumns = [
     {
      key: "financialYear",
      title: "Financial Year",
      sort: true,
      active: false,
      direction: SortDirection.ASC, default: true,
      render: (row: any) => {
        return (
          <Box>
            {row?.financialYear ? (
              (
                <Typography> {row?.financialYear}</Typography>
              )
            ) : (
              "-"
            )}
          </Box>
        );
      },
    },
        {
      key: "name",
      title: (
        <Box display="flex" alignItems="center">
          <PersonOutlineOutlinedIcon style={{ width: "20px", marginRight: "5px" }} />
          Client Name (TAN)
        </Box>
      ),
      sort: true,
      active: false,
      direction: SortDirection.ASC, default: true,
      render: (row) => (
        <Typography
        noWrap
      sx={{
        maxWidth: 350,
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        display: "inline-block",
        verticalAlign: "middle"
      }}
      title={`${row?.tanClientCredentials?.client?.displayName} (${row?.tanClientCredentials?.tanNumber})`}>
          {row?.tanClientCredentials?.client?.displayName} (<span>{row?.tanClientCredentials?.tanNumber}</span>)
        </Typography>
      ),
    },
   
    {
      key: "quarter",
      title: "Quarter",
      sort: true,
      active: false,
      direction: SortDirection.ASC, default: true,
    },

    {
      key: "formType",
      title: "Form Name",
      sort: true,
      active: false,
      direction: SortDirection.ASC, default: true
    },
    {
      key: "netPayableAmount",
       title: (
        <Box display="flex" justifyContent="flex-end" width='100%'>
          Net Payable (Rounded-Off)
        </Box>
      ),
      render:(v:any)=>(
        <Typography align="right">
          {v.netPayableAmount ? formattedAmount(v.netPayableAmount) : "-"}
        </Typography>
      ),
      sort: true,
      active: false,
      direction: SortDirection.ASC, default: true
    },

  ];
  const [sort, setSort] = useState<any>({});
  const [columns, setColumns] = useState(_.cloneDeep(defaultColumns));
  const { data, isLoading }: ResType = useQuery(
    [
      "income-Tax-Tan-demands",
      {
        search: search,
        limit: pageCount,
        offset: page * pageCount,
        ...filters,
        sort
      },
    ],
    getIncomeTaxDemands,
    {
      onSuccess: (res) => {
        setTotalCount(res?.data?.count);
      },
      // enabled: permissions.includes(Permissions.VIEW_ALL_CLIENT_MANAGERS) || permissions.includes(Permissions.VIEW_ASSIGNED_CLIENT_MANAGERS)
    }
  );

  // useEffect(() => {
  //   if (state) {
  //     setFilters({
  //       ...filters,
  //       filingType: state?.filingType,
  //       financialYear: state?.financialYear,
  //       udinStat: state?.udinType,
  //       quarter: state?.quarter,
  //       formCode: state?.formCd
  //     });
  //     setPage(0);
  //   }
  // }, [state]);



  const handleRowClick = (v: any) => {
    navigate(`/atom-pro/income-tax-tan/demand/${v?.id}`);
  };


  const handleformDescChange = (e) => {
    setFilters({ ...filters, formCode: e.target.value });
    setPage(0);
  };

  const handleQuarterChange = (e) => {
    setFilters({ ...filters, quarter: e.target.value });
    setPage(0);
  };

  const handleAssessmentYearChange = (e) => {
    setFilters({ ...filters, financialYear: e.target.value });
    setPage(0);
  };

  const onClientCategoryChange = (e) => {
    setFilters({ ...filters, clientCategory: e.target.value });
    setPage(0);
  };

  const handleSearch = (e) => {
    setSearch(e);
    setPage(0);
  };


  const { mutate: mutate1 } = useMutation(exportTracesIncomeTaxDemands, {
    onSuccess: (res: any) => {
      const arr = new Uint8Array(res.data?.data);
      const blob = new Blob([arr], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const file = window.URL.createObjectURL(blob);
      let link = document.createElement("a");
      const formattedDateTime = getCurrentFormattedDateTime();
      link.href = file;
      link.download = `ATOM Pro - Income Tax (Traces) Demands ${formattedDateTime}.xlsx`;
      link.click();
      snack.success("Income Tax  exported successfully");
    },
    onError: (err: any) => {
      snack.error(err);
      snack.error(handleError(err));
    },
  });
  const handleExport = () => {
    mutate1({
      // ...state,
      ...filters
    });
  };

  const handleSort = (v: any) => {
    sortHandler({
      key: v.key,
      columns,
      sortState: sort,
      setSortState: setSort,
      setColumns: setColumns,
    });
  };

  // if (!(permissions.includes(Permissions.VIEW_ALL_CLIENT_MANAGERS) || permissions.includes(Permissions.VIEW_ASSIGNED_CLIENT_MANAGERS))) {
  //   return <AccessDenied />
  // }

  return (
    <Box m={1}>
      <Box pr={2} pl={2} sx={{ display: "flex" }}>
        <Box display="flex">
          <Box ml={0.5}>
            <TextField
              label="Financial Year"
              value={filters.financialYear || ""}
              sx={{ width: 150 }}
              onChange={handleAssessmentYearChange}
              size="small"
              select
            >
              <MenuItem key={""} value={""}>
                Select
              </MenuItem>
              {financialYear?.map((year, index) => (
                <MenuItem key={index} value={year}>
                  {year}
                </MenuItem>
              ))}
            </TextField>
          </Box>
          <Box>
            <Box ml={0.5}>
              <TextField
                name="clientCategory"
                value={filters.clientCategory || ""}
                onChange={onClientCategoryChange}
                size="small"
                label="Category"
                select
                sx={{ width: "150px" }}
              >
                <MenuItem key={""} value={""}>
                  Select
                </MenuItem>
                {clientCategories.map((category) => (
                  <MenuItem key={category.value} value={category.value}>
                    {category.label}
                  </MenuItem>
                ))}
              </TextField>
            </Box>
          </Box>
          <Box ml={0.5}>
            <TextField
              label="Form Name"
              value={filters.formCode || ""}
              sx={{ width: 120 }}
              onChange={handleformDescChange}
              size="small"
              select
            >
              <MenuItem key={""} value={""}>
                Select
              </MenuItem>
              {forms.map((key, index) => (
                <MenuItem key={index} value={key}>
                  {key}
                </MenuItem>
              ))}
            </TextField>
          </Box>
          <Box ml={0.5}>
            <TextField
              label="Quarter"
              value={filters.quarter || ""}
              sx={{ width: 120 }}
              onChange={handleQuarterChange}
              size="small"
              select
            >
              <MenuItem key={""} value={""}>
                Select
              </MenuItem>
              {quarters.map((key, index) => (
                <MenuItem key={index} value={key}>
                  {key}
                </MenuItem>
              ))}
            </TextField>
          </Box>
        </Box>

        <SearchContainer
          minWidth="300px"
          value={search}
          debounced
          placeHolder="Search by Client Name | TAN"
          onChange={handleSearch}
        />

        <Button
          onClick={() => {
            setFilters({});
            setSearch("");
          }}
          sx={{ marginLeft: "5px", marginRight: "5px" }}
          size="small"
          color="secondary"
          variant="outlined"
        >
          Clear Filters
        </Button>

        <Button
          variant="outlined"
          color="secondary"
          onClick={handleExport}
          startIcon={<FileDownloadOutlinedIcon />}
        >
          Export
        </Button>

      </Box>

      <Box mt={1}>
        <Table
          sx={{ height: '510px' }}
          pagination={{ totalCount, pageCount, setPageCount, page, setPage }}
          data={data?.data.result || []}
          columns={columns}
          sortHandler={handleSort}
          loading={isLoading}
          onRowClick={handleRowClick}
        />
      </Box>
    </Box>
  );
};

export default TanIncomeTaxDemands;
